export const environment = {
  production: false,
  //apiUrl: "https://api-template-0avi.onrender.com/",
  //apiUrl: "http://127.0.0.1:3000/",
  apiUrl: "https://wcybxcffu5ngy57mdswn66j6rm0ybpdb.lambda-url.us-east-1.on.aws/",
};

